import * as actionsImport from './config.actions';
import * as reducersImport from './config.reducers';
import * as selectorsImport from './config.selectors';
import * as typesImport from './config.types';

export const actions = actionsImport;
export const reducers = reducersImport;
export const selectors = selectorsImport;
export const types = typesImport;
